"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Temporary Power",
  description: "...",
  bgUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/temporary_power_site.png",
  link: "/ServicesPage"
}, {
  title: "Distribution Boards",
  description: "...",
  bgUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/distribution_board_install.png",
  link: "/ServicesPage"
}, {
  title: "Groundwork & Wiring",
  description: "...",
  bgUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/electrical_groundwork.png",
  link: "/ServicesPage"
}];
export default function ServiceOverview() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="236396" id="infrastructure-solutions" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`mb-16 max-w-2xl transition-all duration-700 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-3xl font-bold tracking-tighter text-foreground md:text-4xl lg:text-5xl uppercase">
            Industrial Infrastructure
          </h2>
          <p className="mt-4 text-lg font-default text-muted-foreground border-l-2 border-primary pl-6">
            Precision-engineered electrical foundations designed to power large-scale commercial and industrial developments from day one.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 gap-6 md:grid-cols-3 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="group relative h-[450px] w-full overflow-hidden rounded-none border border-border md:h-[550px]">
              {}
              <div className="absolute inset-0 bg-cover bg-center grayscale transition-all duration-1000 ease-out group-hover:scale-105 group-hover:grayscale-0" style={{
            backgroundImage: `url(${service.bgUrl})`
          }} />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/100 via-background/40 to-transparent transition-opacity duration-500 group-hover:opacity-95" />

              {}
              <div className="absolute inset-0 flex flex-col justify-end p-8">
                <div className="transform transition-transform duration-500 ease-out group-hover:-translate-y-2">
                  <h3 className="font-default text-2xl font-bold text-foreground md:text-3xl uppercase tracking-tight">
                    {service.title}
                  </h3>
                  
                  {}
                  <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-out group-hover:grid-rows-[1fr]">
                    <div className="overflow-hidden opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100">
                      <p className="mt-3 mb-6 text-sm font-default leading-relaxed text-muted-foreground md:text-base">
                        {service.description}
                      </p>
                      <Button asChild variant="outline" className="rounded-none border-primary bg-primary text-primary-foreground font-bold hover:bg-transparent hover:text-primary transition-colors">
                        <Link to={service.link}>
                          VIEW SPECS <ArrowRight className="ml-2 size-4" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute top-4 right-4 opacity-30 font-mono text-[10px] text-primary pointer-events-none">
                51.5074° N, 0.1278° W
              </div>
              <div className="absolute top-4 left-4 opacity-30 font-mono text-[10px] text-primary pointer-events-none">
                GRID_REF: {i}00-X
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}